<div class="container ">
  <app-loading *ngIf="!(providerInput && providerInfo) || showLoading"></app-loading>

  <ng-container *ngIf="form">
    <div *ngIf="providerInput && providerInfo">

      <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div>
          <app-provider-info [providerInfo]="providerInfo"></app-provider-info>
        </div>
        <div class="form-container">
          <div>
            <app-provider-field *ngFor="let input of providerInput" [providerInput]="input" [form]="form" [onDropdownChange]="onDropdownChange">
            </app-provider-field>
          </div>
          <div>
            <button type="submit">{{ 'Buttons.continue' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
</div>
<app-popup [(show)]="showPopup" [messages]="popupMessages" [message]="popupMessage" (closed)="showPopup = $event">
</app-popup>